import { FaCog, FaUsers, FaUserSlash } from "react-icons/fa";
import { UPLOAD_URL } from "../../../utils/constants";
import { useState } from "react";
import { convertStringToBoolean } from "../../../helpers/function.helper";
import {
  getPrivacyOverlayLabel,
  shouldBlurProfileImage,
} from "../../../utils/imagePrivacy";

type SettingsModalProps = {
  closeSettingsModal: () => void;
  profile: any;
};

const SettingsModal = ({ closeSettingsModal, profile }: SettingsModalProps) => {
  const [showOtherProfilesLoading, setShowOtherProfilesLoading] =
    useState(false);

  // Toggle show other profiles
  const toggleShowOtherProfiles = async (
    profileId: string,
    currentShowOtherProfiles: boolean | string,
  ) => {
    setShowOtherProfilesLoading(true);

    try {
      const currentBooleanShowOtherProfiles = convertStringToBoolean(
        currentShowOtherProfiles,
      );
      const newShowOtherProfiles = !currentBooleanShowOtherProfiles;

      // const response = await postRequest(
      //   `${apiEndpoints.showotherprofiles}/${profileId}`,
      //   {
      //     showOtherProfiles: newShowOtherProfiles,
      //   }
      // );

      // if (response.data.success) {
      //   setProfile((prev: any) => ({
      //     ...prev,
      //     showOtherProfiles: newShowOtherProfiles,
      //   }));

      //   const status = newShowOtherProfiles ? "show" : "don't show";
      //   const description = newShowOtherProfiles
      //     ? "This profile can now see other profiles"
      //     : "This profile cannot see other profiles";

      //   alert(`Profile will ${status} other profiles! ${description}`);
      // } else {
      //   throw new Error(
      //     response.data.message ||
      //       "Failed to update show other profiles setting"
      //   );
      // }
    } catch (error: any) {
      console.error("Error updating show other profiles:", error);
      const errorMessage =
        error.response?.data?.message ||
        error.message ||
        "Error updating show other profiles setting. Please try again.";
      alert(errorMessage);
    } finally {
      setShowOtherProfilesLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
      <div className="bg-white rounded-lg p-6 w-96 max-w-md mx-4">
        <div className="flex items-center justify-between mb-4">
          <h2 className="text-xl font-bold flex items-center">
            <FaCog className="mr-2 text-blue-600" />
            Settings
          </h2>
          <button
            onClick={closeSettingsModal}
            className="text-gray-500 hover:text-gray-700 text-xl"
          >
            ×
          </button>
        </div>

        <div className="mb-4">
          <div className="flex items-center mb-2">
            <div className="relative w-12 h-12 mr-3">
              <img
                src={
                  profile.image
                    ? `${UPLOAD_URL}/users/profile_pic/${profile.image}`
                    : "https://www.pngitem.com/pimgs/m/581-5813504_avatar-dummy-png-transparent-png.png"
                }
                alt="Profile"
                className={`w-full h-full object-cover rounded-full ${
                  shouldBlurProfileImage(profile.imagePrivacy)
                    ? "blur-lg scale-110 brightness-90"
                    : ""
                }`}
              />
              {shouldBlurProfileImage(profile.imagePrivacy) && (
                <div className="absolute inset-0 bg-black/50 rounded-full text-white text-[8px] font-semibold tracking-wide uppercase flex flex-col items-center justify-center text-center pointer-events-none px-1">
                  <span>{getPrivacyOverlayLabel(profile.imagePrivacy)}</span>
                  <span className="text-[7px] opacity-80">Hidden</span>
                </div>
              )}
            </div>
            <div>
              <h3 className="font-semibold">{profile.fullName}</h3>
              <p className="text-sm text-gray-600">ID: {profile.martialId}</p>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-200 pt-4 mb-6">
          <h4 className="font-semibold mb-3 text-center">
            Show Other Profiles
          </h4>

          <div className="space-y-3">
            {/* Show Option */}
            <div
              onClick={() =>
                toggleShowOtherProfiles(profile._id, profile.showOtherProfiles)
              }
              className={`p-4 rounded-lg border-2 cursor-pointer transition-all ${
                profile.showOtherProfiles
                  ? "border-blue-500 bg-blue-50 shadow-md"
                  : "border-gray-200 bg-gray-50 hover:border-blue-300"
              }`}
            >
              <div className="flex items-center">
                <div
                  className={`w-4 h-4 rounded-full border-2 mr-3 flex items-center justify-center ${
                    profile.showOtherProfiles
                      ? "border-blue-500 bg-blue-500"
                      : "border-gray-300"
                  }`}
                >
                  {profile.showOtherProfiles && (
                    <div className="w-2 h-2 bg-white rounded-full"></div>
                  )}
                </div>
                <FaUsers
                  className={`mr-3 ${
                    profile.showOtherProfiles
                      ? "text-blue-600"
                      : "text-gray-400"
                  }`}
                  size={18}
                />
                <div>
                  <p className="font-medium">Show</p>
                  <p className="text-sm text-gray-600">
                    This profile can see other profiles
                  </p>
                </div>
              </div>
            </div>

            {/* Don't Show Option */}
            <div
              onClick={() =>
                toggleShowOtherProfiles(profile._id, profile.showOtherProfiles)
              }
              className={`p-4 rounded-lg border-2 cursor-pointer transition-all ${
                !profile.showOtherProfiles
                  ? "border-red-500 bg-red-50 shadow-md"
                  : "border-gray-200 bg-gray-50 hover:border-red-300"
              }`}
            >
              <div className="flex items-center">
                <div
                  className={`w-4 h-4 rounded-full border-2 mr-3 flex items-center justify-center ${
                    !profile.showOtherProfiles
                      ? "border-red-500 bg-red-500"
                      : "border-gray-300"
                  }`}
                >
                  {!profile.showOtherProfiles && (
                    <div className="w-2 h-2 bg-white rounded-full"></div>
                  )}
                </div>
                <FaUserSlash
                  className={`mr-3 ${
                    !profile.showOtherProfiles
                      ? "text-red-600"
                      : "text-gray-400"
                  }`}
                  size={18}
                />
                <div>
                  <p className="font-medium">Don't Show</p>
                  <p className="text-sm text-gray-600">
                    This profile cannot see other profiles
                  </p>
                </div>
              </div>
            </div>
          </div>

          {showOtherProfilesLoading && (
            <div className="text-center mt-4">
              <div className="inline-flex items-center">
                <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-blue-600 mr-2"></div>
                <span className="text-sm text-gray-600">Updating...</span>
              </div>
            </div>
          )}
        </div>

        <div className="flex space-x-3">
          <button
            onClick={closeSettingsModal}
            className="flex-1 px-6 py-3 bg-gray-200 text-gray-800 rounded-lg font-medium hover:bg-gray-300 transition-colors"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default SettingsModal;
